import { gql } from '@apollo/client';

import accountFields from '../fragments/accountFields';
import assetFields from '../fragments/assetFields';
import listingFields from '../fragments/listingFields';

const assetFullQuery = gql`
  ${assetFields}
  ${accountFields}
  ${listingFields}
  #$accountAsset: String!
  query Asset($assetId: String!) {
    asset(id: $assetId) {
      ...AssetField
      activeListings {
        ...ListingField
      }
      #currentOwners: owners(where: { id: $accountAsset }) {
      #  id
      #  quantity
      #}
      #allOwners: owners {
      #  id
      #  quantity
      #  account {
      #    ...AccountField
      #  }
      #}
    }
  }
`;

export default assetFullQuery;
